import { render, staticRenderFns } from "./officialTopupApp.vue?vue&type=template&id=16a3b7fb&"
import script from "./officialTopupApp.vue?vue&type=script&lang=js&"
export * from "./officialTopupApp.vue?vue&type=script&lang=js&"
import style0 from "./officialTopupApp.vue?vue&type=style&index=0&id=16a3b7fb&prod&lang=css&"
import style1 from "./officialTopupApp.vue?vue&type=style&index=1&id=16a3b7fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports